<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Search Agreement List">
      <template>
        <div class="w-full flex justify-items-auto gap-3 items-stretch">
          <vs-input class="mt-5 mb-5" placeholder="Mobile No" v-model="mobile"/>
          <vs-input class="mt-5 mb-5" placeholder="Article No" v-model="article"/>
            <datepicker class="mt-5 mb-5"
              :format="formatedDate(start_dt)"
              v-validate="'required'"
              placeholder="Start Date"
              v-model="start_dt"
            />
            <datepicker class="mt-5 mb-5"
              :format="formatedDate(end_dt)"
              v-validate="'required'"
              placeholder="End Date"
              v-model="end_dt"
            />
          <vs-button class="mt-5 mb-5" color="rgb(0 121 193)"  icon-pack="feather" icon="icon-search" @click="serachApplication()" >Search</vs-button>
        </div>
      </template>
      <table class="table w-full">
        <thead>
        <tr>
          <th>Agreement No</th>
          <th>Agreement Date</th>
          <th>Article</th>
          <th>Product</th>
          <th>Client Name</th>
          <th>Mobile</th>
          <th>Showroom</th>
        </tr>
        </thead>
        <tbody>
          <tr class="border-b border-grey-500" :key="aggreement.id" v-for="aggreement in applicationList">
            <td class="text-left px-2 py-3">{{aggreement.invoice_number}}</td>
            <td class="text-left px-2 py-3">{{formatedDate(aggreement.accepting_date)}}</td>
            <td class="text-left px-2 py-3">{{aggreement.product_master.article}}</td>
            <td class="text-left px-2 py-3">{{aggreement.product.product}}</td>
            <td class="text-left px-2 py-3">{{aggreement.user.ekyc.parsonal.name}} {{aggreement.user.ekyc.parsonal.last_name}}</td>
            <td class="text-left px-2 py-3">{{aggreement.user.ekyc.phone}}</td>
            <td class="text-left px-2 py-3">{{aggreement.showroom.suffix}} ({{aggreement.showroom.address}})</td>
          </tr>
        </tbody>
      </table>
      <p class="text-center">{{message}}</p>
    </vx-card>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from "../axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import StatisticsCardLine from "../components/statistics-cards/StatisticsCardLine";
import SuffixPieChart from "./SuffixPieChart";

export default {
  data() {
    return {
      selected:[],
      mobile:'',
      article:'',
      start_dt:'',
      end_dt:'',
      applicationList:[],
      message:''

    }
  },
  computed: {
    ...mapGetters(['meta'])
  },
  components: {
    Datepicker
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    serachApplication(){
        const start_dt = this.formatedDate(this.start_dt);
        const end_dt = this.formatedDate(this.end_dt);
        axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/find-agreement?mobile=${this.mobile}&article=${this.article}&start_dt=${start_dt}&end_dt=${end_dt}`).then(response => {
          this.applicationList = response.data;
          this.message = '';
        })
        .catch(error => {
          this.applicationList = [];
          this.message = 'No Data Found.';
        })
      },


    formatedDate(date) {
      return moment(date).format("yyyy-MM-DD");
    },
  }
}


</script>

